<template>
    <div class="father">
        <person></person>
    </div>
</template>

<script>
import Person from '@/views/personCenter/Person.vue';

export default {
    components: {
        Person,
    },
};
</script>

<style lang="scss" scoped>
    .father {
        min-width: 1200px;
        background: #F9F9F9;
    }
</style>
